export default "__VITE_ASSET__DF5s96YQ__"